import React, { useEffect, useState } from "react";
import { Modal, ModalDialog, Button } from "@mui/joy";
import { postFetch } from "../../../../../../fetch/fetch";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styles from "./phoneinbound.module.css";

const toastOptions : any = {
    position: "bottom-right",
    autoClose: 3000,
    hideProgressBar: true,
    theme: "colored"
};

const statusText : any = {
    available: "대기",
    busy: "통화중",
    offline: "폰 꺼짐",
    paused: "수신 안 함"
};

//수신자 상세 + 제거 (행에는 제거 버튼을 두지 않고 여기서만, 확인 단계 포함)
const ReceiverDetailModal : React.FC<any> = (props) => {

    const [confirming, setConfirming] = useState<boolean>(false);
    const [deleting, setDeleting] = useState<boolean>(false);

    useEffect(() => {
        if (props.open) {
            setConfirming(false);
            setDeleting(false);
        }
    }, [props.open]);

    const r = props.receiver;
    if (!r) {
        return null;
    }

    const queueName = (queue : string) => (props.queueNames && props.queueNames[queue]) || queue;

    const remove = async () => {
        setDeleting(true);
        try {
            const result : any = await postFetch("/dashboard/callcenter/receivers/delete", { receiverId: r.id });
            if (result.message === "success") {
                toast.success("수신자를 제거했습니다", toastOptions);
                props.onDeleted(r.id);
                props.onClose();
            } else {
                toast.error("교환기 반영 실패", toastOptions);
            }
        } catch (e) {
            console.log(e);
            toast.error("교환기 반영 실패", toastOptions);
        }
        setDeleting(false);
    };

    return (
        <Modal open={props.open} onClose={props.onClose}>
            <ModalDialog>
                <div style={{ width: "360px" }}>
                    <div className={styles.modalTitle}>{r.name}</div>

                    <div className={styles.detailRow}><span className={styles.detailKey}>내선</span><span>{r.extension}</span></div>
                    <div className={styles.detailRow}>
                        <span className={styles.detailKey}>구분</span>
                        <span>{r.receiverType === "branch" ? `지점 폰 — ${queueName(r.branchQueue)} 큐` : "본사팀 — 전 지점 수신"}</span>
                    </div>
                    <div className={styles.detailRow}><span className={styles.detailKey}>우선순위</span><span>{r.priority}</span></div>
                    <div className={styles.detailRow}><span className={styles.detailKey}>수신</span><span>{r.enabled ? "수신 중" : "수신 안 함"}</span></div>
                    <div className={styles.detailRow}><span className={styles.detailKey}>현재 상태</span><span>{statusText[r.liveStatus] || "—"}</span></div>

                    <div className={styles.detailQueueList}>
                        {
                            (r.queues || []).map((q : any) => (
                                <div key={q.queue}>
                                    {queueName(q.queue)} 큐 · {q.present ? `등록됨 · ${q.paused ? "수신 안 함" : "수신 중"} · 우선순위 ${q.priority}` : "교환기에 미등록"}
                                </div>
                            ))
                        }
                    </div>

                    {
                        r.desynced && r.desyncReasons && r.desyncReasons.length > 0 ?
                            <div className={styles.warnLine} style={{ marginTop: "10px" }}>
                                교환기 설정과 다릅니다: {r.desyncReasons.join(" / ")} (서버 재시작 또는 동기화 시 DB 기준으로 맞춰집니다)
                            </div>
                            :
                            ""
                    }

                    {
                        confirming ?
                            <div className={styles.confirmBox}>
                                정말 제거할까요? 이 수신자는 {r.receiverType === "branch" ? "해당 지점 큐" : "그룹의 모든 큐"}에서 빠지며 전화를 받지 않게 됩니다.
                            </div>
                            :
                            ""
                    }

                    <div className={styles.modalButtons}>
                        {
                            confirming ?
                                <>
                                    <Button variant="plain" color="neutral" onClick={() => setConfirming(false)} disabled={deleting}>취소</Button>
                                    <Button variant="solid" color="danger" onClick={remove} loading={deleting}>제거 확인</Button>
                                </>
                                :
                                <>
                                    <Button variant="plain" color="neutral" onClick={props.onClose}>닫기</Button>
                                    <Button variant="outlined" color="danger" onClick={() => setConfirming(true)}>수신자 제거</Button>
                                </>
                        }
                    </div>
                </div>
            </ModalDialog>
        </Modal>
    );
};

export default ReceiverDetailModal;
